import type { Types } from '@fiverr-private/theme';
import { DrawerSizeType } from '../types';

export const HEADER_APPROX_HEIGHT = '76px';
export const SIDE_PADDING = `60px`;

export const DIALOG_MAX_WIDTH: { [key in DrawerSizeType]: Types.ResponsiveWidthType } = {
    sm: '375px',
    md: '480px',
    lg: '600px',
    xl: '900px',
};
